<template>
  <div>
    <b-card bg-variant="light" text-variant="dark" class="mt-3">
        <b-card-text >
        <div class="row mt-3">
        <div class="col-12 col-md-6 ">
        <h2 class="display-5">{{ user.name }}</h2>
        <p>{{ user.username }}</p>
        </div>
        <div class="col-12 col-md-6">
         <div v-if="user && user.id" class="imagePreviewWrapper">
         <b-img thumbnail v-b-modal.profil-image-modal rounded="" class="profil-image" :src="iconUrl" alt="Profil Bild"></b-img>
         </div>
        <b-modal id="profil-image-modal" :title="user.name" hide-footer>
         <div v-if="user && user.id" class="imagePreviewWrapperLarge">
         <b-img thumbnail class="profil-image-large" :src="iconUrl" alt="Profil Bild"></b-img>
         </div>
        </b-modal>
        <b-link v-if="user.pageUrl" :href="user.pageUrl" target="_new" class="btn btn-secondary btn-sm ">Zum Profil</b-link>
        <b-button-toolbar >
            <b-input-group v-if="editMode && hasRoles(['Admin','Disponent'])"  size="sm">
            <b-form-file accept="image/jpeg, image/png, image/gif"
          v-model="profilBild"
          :state="Boolean(profilBild)"
          placeholder="Bild auswählen"
          drop-placeholder="Hierhin ziehen..."
        ></b-form-file>
        </b-input-group>
        <b-button-group size="sm" class="">
          <b-button v-if="editMode && hasRoles(['Admin','Disponent'])" @click="uploadFile" variant="default" aria-label="Bild setzen"><i class="h3 bi bi-person-plus p-1"></i></b-button>
          <b-button v-if="editMode && hasRoles(['Admin','Disponent'])" @click="clearFile" variant="default" aria-label="Bild entfernen"><i class="h3 bi bi-person-dash p-1"></i></b-button>
        </b-button-group>
        </b-button-toolbar>
        </div>
      </div>
        <div class="row ">

        <div class="col-12 col-md-6">
        <div v-if="hasRoles(['Admin','Disponent','Cutter'])">
        <div><strong>Vermittelte Gagen</strong></div>
        <div>{{ gesamtGage.toLocaleString('de-DE') }} EUR</div>
        <div><strong>Provisionen und Jahrsbeiträge</strong></div>
        <div>- {{ sumProvisions().toLocaleString('de-DE') }} EUR</div>
        <div><strong>Dein Gewinn durch Die Cutterkollegen</strong></div>
        <div>{{ (gesamtGage - sumProvisions()).toLocaleString('de-DE') }} EUR</div>
        </div>
        </div>
     </div>
     </b-card-text>
    </b-card>

     <b-card class="mt-3" header="white" v-if="hasRoles(['Admin','Disponent','Cutter']) && user.folgetage && user.folgetage.length>0">
      <template #header>
      <h3>Folgetage</h3>
      </template>
      <b-card-text>
         <div v-for="(tag, idx) in user.folgetage" :key="idx">
         {{tag.name}}<span v-if="tag.wert!=0">: {{tag.wert}} Tage</span>
         </div>
         <div class="mt-2">
         <ConfigurableText ref="ConfigurableText" id="TEXT_FOLGETAGE_INFO"/>
         </div>
      </b-card-text>
    </b-card>

    <b-card class="mt-3" header="white">
      <template #header>
    <h3 class="underline clearfix pt-3">
        Kontaktdaten & Passwort
        <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
        abbrechen
        </b-button>
        <b-button v-if="!editMode" :pressed.sync="editMode" variant="default" class="profile_button float-right">
          <span class="bi-pencil" aria-hidden="true"></span>
        </b-button>
        <b-button v-if="editMode" @click="saveData" size="sm" variant="primary" class="float-right">
        speichern
        </b-button>
      </h3>

      </template>
      <b-card-text>
      <b-form-group
      label="Strasse"
      label-for="input-strasse"
      class="mb-0"  >
          <b-form-input id="input-strasse" :plaintext="!editMode" :readonly="!editMode" v-model="user.strasse" placeholder="nicht vorhanden" ></b-form-input>
       </b-form-group>
  <div class="row">
    <div class="col-xs-12 col-md-2">
          <b-form-group
          label="PLZ"
          label-for="input-plz"
          class="mb-0"  >
              <b-form-input id="input-plz" :plaintext="!editMode" :readonly="!editMode" v-model="user.plz" placeholder="nicht vorhanden" ></b-form-input>
           </b-form-group>
    </div>
    <div class="col-xs-12 col-md-10">
          <b-form-group
          label="Ort"
          label-for="input-ort"
          class="mb-0"  >
              <b-form-input id="input-ort" :plaintext="!editMode" :readonly="!editMode" v-model="user.ort" placeholder="nicht vorhanden" ></b-form-input>
           </b-form-group>
    </div>
  </div>
      <b-form-group
      label="Telefon"
      label-for="input-telefon"
      class="mb-0"  >
      <b-form-input id="input-telefon" :plaintext="!editMode" v-model="user.telefon" placeholder="nicht vorhanden" :readonly="!editMode"></b-form-input>
      </b-form-group>
      <b-form-group
      label="E-Mail"
      label-for="input-email"
      class="mb-0"  >
      <b-form-input id="input-email" :plaintext="!editMode" v-model="user.email"  placeholder="nicht vorhanden" :readonly="!editMode" type="email"></b-form-input>
      </b-form-group>

      <b-form-group
      label="Zugangsdaten Cutterkollegen-Mailadresse"
      label-for="input-zugangsdaten"
      class="mb-0"  >
      <b-form-textarea id="input-zugangsdaten" :plaintext="!(editMode && hasRoles(['Admin']))" v-model="user.zugangsdaten" placeholder="nicht vorhanden" :readonly="!(editMode && hasRoles(['Admin']))"></b-form-textarea>
      </b-form-group>

      <div v-if="editMode && profil" class="mt-3">
         <PasswordChange ref="PasswordChange" :user="user"/>
     </div>
      <div v-if="editMode && !profil" class="mt-3">
        <PasswortSet ref="PasswortSet" :user="user"/>
     </div>
      </b-card-text>
    </b-card>
       <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
        abbrechen
        </b-button>
        <b-button v-if="editMode" @click="saveData" size="sm" variant="primary" class="float-right">
        speichern
        </b-button>
  </div>
</template>

<script>
import utils from '@/utilities'
import api from '@/api/benutzer'
import PasswordChange from '@/components/partials/PasswordChange'
import PasswortSet from '@/components/partials/PasswordSet'
import ConfigurableText from '@/components/partials/ConfigurableText'

export default {
  props: ['user', 'profil'],
  name: 'Daten',
  components: {PasswordChange, PasswortSet, ConfigurableText},
  methods: {
    sumProvisions () {
      let sum = 0
      if (this.user.provisionen) {
        for (let i = 0; i < this.user.provisionen.length; i++) {
          sum += this.user.provisionen[i].wert
        }
      }
      return sum
    },
    updateIconUrl () {
      let iconUrl = '/api/user/profilePicture/' + (this.user ? this.user.id : 0) + '?' + new Date().getTime()
      this.iconUrl = iconUrl
      return iconUrl
    },
    async uploadFile () {
      var formData = new FormData()
      formData.append('fileName', this.profilBild.name)
      formData.append('file', this.profilBild)
      await api.setLogo(this.user.id, formData)
      let newUser = await api.get(this.user.id)
      if (newUser) {
        this.$bubble('userchanged', newUser)
        this.updateIconUrl()
      }
    },
    async clearFile () {
      await api.clearLogo(this.user.id)
      let newUser = await api.get(this.user.id)
      this.$bubble('userchanged', newUser)
      // das muss doch auch besser gehen?
      this.updateIconUrl()
    },
    async saveData () {
      var formData = new FormData()
      formData.append('plz', this.user.plz)
      formData.append('strasse', this.user.strasse)
      formData.append('ort', this.user.ort)
      formData.append('telefon', this.user.telefon)
      formData.append('email', this.user.email)
      formData.append('zugangsdaten', this.user.zugangsdaten)
      await api.update(this.user.id, formData)
      let newUser = await api.get(this.user.id)
      this.$bubble('userchanged', newUser)
      this.editMode = false
    },
    hasRole (role) {
      return this.hasRoles([role])
    },
    hasRoles (role) {
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), role)
    }
  },
  updated () {
    if (this.iconUrl.includes('undefined')) {
      this.updateIconUrl()
    }
  },
  computed: {
    gesamtGage () {
      return ((this.user && this.user.gageOffset != null) ? (this.user.gageOffset * 1 + (this.user.gagen ? this.user.gagen * 1 + this.user.technikMieten * 1 : 0)) : 0)
    }
  },
  data () {
    return {
      editMode: false,
      profilBild: null,
      iconUrl: this.updateIconUrl(),
      myToggle: false,
      localUser: this.$store.state.auth.user
    }
  }
}
</script>

<style scoped>
.imagePreviewWrapper {
  width: 300px;
  display: block;
  overflow: hidden;
  cursor: pointer;
  padding-bottom: 0.25em;
  background-color: white;
  background-size: cover;
  border: solid 8px white;
  background-position: center center;
}
@media (max-width: 568px) {
.imagePreviewWrapper {
  width: 100%;
  }
}

.profil-image {
  transform-origin: 48% 5%;
  transform:scale(1.8);
}

</style>



// WEBPACK FOOTER //
// src/main/vue/components/profil/Daten.vue